/*
 * File: CustomButton.tsx
 * Project: a-a
 * File Created: Tuesday, 8th October 2024 7:56:16 pm
 * Author: Jackson Thounaojam (jackson.thounaojam@mutualmobile.com)
 * -----
 * Last Modified: Tuesday, 22nd July 2025 12:05:47 am
 * Modified By: Jackson Thounaojam (jackson.thounaojam@mutualmobile.com)
 * -----
 * Copyright 2020 - 2024 Mutual Mobile, Mutual Mobile
 */
import { Typography } from '@mui/material';
import Button from '@mui/material/Button';
import { SxProps, Theme } from '@mui/system';
import React, { ReactNode } from 'react';

type CustomButtonType = {
  variant: 'text' | 'contained' | 'outlined';
  color?:
    | 'inherit'
    | 'primary'
    | 'secondary'
    | 'success'
    | 'error'
    | 'info'
    | 'warning'
    | 'customDisable'
    | 'customSecondary';
  text: string | ReactNode;
  style?: React.CSSProperties | SxProps<Theme> | undefined;
  textStyle?: React.CSSProperties | SxProps<Theme> | undefined;
  icon?: ReactNode;
  iconPosition?: 'start' | 'end';
  onClick: any;
  disabled: boolean;
  tabindex?: number;
  buttonVariant?:
    | 'buttonSmall'
    | 'buttonMedium'
    | 'buttonLarge'
    | 'responsiveButtonLarge'
    | 'responsiveButtonMedium';
};

const CustomButton = ({
  variant,
  color,
  text,
  style,
  textStyle,
  icon,
  iconPosition,
  onClick,
  disabled,
  tabindex,
  buttonVariant = 'buttonMedium',
}: CustomButtonType) => {
  return (
    <Button
      variant={variant}
      color={color}
      sx={style ? { ...style } : {}}
      startIcon={iconPosition === 'start' && icon}
      endIcon={iconPosition === 'end' && icon}
      disableRipple
      disableElevation
      onClick={onClick}
      disabled={disabled}
      tabIndex={tabindex}
    >
      <Typography
        variant={
          buttonVariant === 'buttonSmall'
            ? 'buttonSmall'
            : buttonVariant === 'buttonMedium'
            ? 'buttonMedium'
            : buttonVariant === 'buttonLarge'
            ? 'buttonLarge'
            : buttonVariant === 'responsiveButtonLarge'
            ? 'responsiveButtonLarge'
            : 'responsiveButtonMedium'
        }
        sx={textStyle ? { ...textStyle } : {}}
      >
        {text}
      </Typography>
    </Button>
  );
};

export default CustomButton;
